/**
 * Router-shell de /comercial/formularios — construtor de formularios.
 *
 *   /comercial/formularios                 -> Lista
 *   /comercial/formularios/:id             -> Editor (builder)
 *   /comercial/formularios/:id/respostas   -> Respostas (submissoes)
 *   /comercial/formularios/:id/dashboard   -> Dashboard (metricas)
 *   /comercial/formularios/:id/publicar    -> Publicar (site externo)
 *
 * Editor / Respostas / Dashboard sao as 3 visoes de um mesmo formulario,
 * navegaveis pelas abas (FormTabs).
 *
 * Espelha o shell de /crm: `<Routes location key>` forca o remount da arvore
 * interna a cada mudanca de URL, evitando que a Lista (com hooks de fetch)
 * permaneca montada ao navegar para o Editor.
 */
import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import Dashboard from "./Dashboard";
import Editor from "./Editor";
import Lista from "./Lista";
import Design from "./Design";
import Publicar from "./Publicar";
import Respostas from "./Respostas";

export default function Formularios() {
  const location = useLocation();
  return (
    <Routes location={location} key={location.pathname}>
      <Route index element={<Lista />} />
      <Route path=":id" element={<Editor />} />
      <Route path=":id/respostas" element={<Respostas />} />
      <Route path=":id/dashboard" element={<Dashboard />} />
      <Route path=":id/publicar" element={<Publicar />} />
      <Route path=":id/design" element={<Design />} />
    </Routes>
  );
}
